var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<a href ng-disabled=\"$ctrl.ngDisabled\"><i class=\"m-l-1 fa fa-lg text-primary fa-{{::$ctrl.icon||'wrench'}}\"></i><span ng-if=\"$ctrl.label\">&nbsp;{{::$ctrl.label||''}}</span></a>";
var id1="ibox.toolbar.icon.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;